import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { RedirectAreaActionsProps } from './props';
import { useRedirectAreaListActions } from './hook';

export const RedirectAreaListActions = ({ id }: RedirectAreaActionsProps) => {
    const { handleEdit } = useRedirectAreaListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
